import type { SceneNodeInfo } from "../../../../shared/api-contract";

/**
 * Map the selection to a scene-tree node.
 *
 * The editor holds TWO id spaces and they are not interchangeable: the
 * selection slice carries a **material-group id** (what the picker and the
 * material sections address), while the scene tree, the transform gizmo and the
 * v58 node inspector all address a **node id**. `SceneNodeInfo.groupId` is the
 * only link between them, and it is set on meshes only.
 *
 * Extracted from TransformControl, which had the first copy, so the gizmo and
 * the inspector cannot disagree about which node a selection means — two
 * resolvers over one mapping is the drift this repo keeps documenting.
 */
export function findNodeByGroupId(nodes: SceneNodeInfo[], groupId: string): SceneNodeInfo | null {
  for (const n of nodes) {
    if (n.groupId === groupId) return n;
    const found = findNodeByGroupId(n.children, groupId);
    if (found) return found;
  }
  return null;
}

/** Flatten the tree, parents before children. */
export function flattenNodes(nodes: SceneNodeInfo[], out: SceneNodeInfo[] = []): SceneNodeInfo[] {
  for (const n of nodes) {
    out.push(n);
    flattenNodes(n.children, out);
  }
  return out;
}
